import { useMemo } from 'react';
import useTrackingCore from './core';

export default function useProtectionTracking() {
  const {
    trackEventWithCouponTotalTicketsAndTimeRemaining,
    trackLeavePageEvent,
  } = useTrackingCore();

  const ticketProtectionTrackingFunctions = useMemo(() => {
    return {
      ticketProtectionViewed: (protectionPrice) => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'ticket_protection_viewed',
          {
            ticket_protection_price: protectionPrice,
          },
        );
        // agregar total de boletos
      },
      ticketProtectionContinueClicked: (
        protectionSelected,
        protectionPrice,
      ) => {
        trackEventWithCouponTotalTicketsAndTimeRemaining(
          'ticket_protection_continue_clicked',
          {
            ticket_protection_selected: protectionSelected,
            ticket_protection_price: protectionPrice,
          },
        );
      },
      ticketProtectionAbandoned: () => {
        trackLeavePageEvent('ticket_protection_abandoned', {});
      },
    };
  }, [trackEventWithCouponTotalTicketsAndTimeRemaining, trackLeavePageEvent]);

  return ticketProtectionTrackingFunctions;
}
